import { Layout, LayoutProps} from 'react-admin';
import {CustomMenu} from "./custom-menu";
import CustomAppBar from "./custom-app-bar";

export const CustomLayout = (props: JSX.IntrinsicAttributes & LayoutProps) => <Layout {...props} menu={CustomMenu} appBar={CustomAppBar} />;